import styled from "styled-components";

export const DescriptionContainer = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: gray;
  margin-bottom: 5px;
  margin-left: 5px;
`;